import createVueApp from '@phoenix/createVueApp';
import MixedGrid from '@maison/components/mixedGrid/MixedGrid.vue';

Array.from(document.querySelectorAll('.phoenix-mixed-grid')).forEach((el) => {
  const app = createVueApp({}, true);
  app.component('MixedGrid', MixedGrid);
  app.mount(el);
});
